import './priceAndShopTable.scss';



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/shared/PriceAndShopTable/index.js